import { useCallback, useEffect } from "react";

export function usePreventEnterOnInputElements(onEnter: () => void = () => {}) {
  const preventEnterOnInputElements = useCallback((e: any) => {
    // Enter key is keyCode 13
    if (e.keyCode === 13 && e.target instanceof HTMLInputElement) {
      e.preventDefault();
      onEnter();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", preventEnterOnInputElements);
    return () => {
      window.removeEventListener("keydown", preventEnterOnInputElements);
    };
  }, [preventEnterOnInputElements]);
}
